class CustomProductsGridActions {
    init() {
        const lsValue = localStorage.getItem('data-products-grid-action');
        const attribute = document.body.getAttribute('data-products-grid-action');
        if (!attribute) {
            let value = '1';
            if (lsValue) value = lsValue;
            document.body.setAttribute('data-products-grid-action', value);
        }
        document.querySelector('[data-products-grid-action-container]')
            .addEventListener('click', (event) => {
                let itemId = null;
                let temp = event.target;
                for (let i=0; i<5; i++) {
                    const attribute = temp.getAttribute('data-products-grid-action');
                    if (attribute) {
                        itemId = attribute;
                        break;
                    }
                    temp = temp.parentNode;
                }
                if (itemId) {
                    document.body.setAttribute('data-products-grid-action', itemId);
                    localStorage.setItem('data-products-grid-action', itemId);
                }
            });
    }
}